import React, { Component, Fragment } from "react"
import { pick, get, has, map, concat, split, filter, isEmpty } from "lodash"

import "./index.less"
import alarmIcon from "../../images/alarm.svg"
import DimensionBox from "../DimensionBox"
import DimensionBoxEnps from "../DimensionBox/DimensionBoxEnps"
import DimensionBoxMultipleChoice from "../DimensionBox/DimensionBoxMultipleChoice"

const SurveyQuestions = (props) => {
  const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
  return (
    <React.Fragment>
      {!!get(props.surveyName, "measures", []).length && (
        <div className="show-alert-survey-process">
          <img src={alarmIcon} style={{ marginRight: 24 }} />
          <div>
            <div className="show-alert-survey-process-title">
              ¡El cuestionario está siendo utilizado en una medición en curso, por lo cual algunas acciones de edición pueden verse limitadas!
            </div>
            <div>
              Únicamente podrás editar los enunciados de las preguntas y títulos de subdimensiones y dimensiones, así como añadir preguntas cualitativas.
            </div>
            <ul className="show-alert-survey-process-list">
              {map(get(props.surveyName, "measures", []), (item, index) => {
                return (
                  <li key={index}>
                    <span>Medición en curso: </span>
                    {item.name}
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )}
      <div className= {`container-of-items ${hasFreshchat ? "hasPaddingChat" : ""}`} >
        {props.survey.map((item, index) => {
          return (
            <DimensionBox
              idSurvey={props.match.params.id}
              key={index}
              toggleDrawer={props.setStateFrom}
              showOptions
              item={item}
              measures={get(props.surveyName, "measures", [])}
              updateQuestionDimensionWatcher={
                props.updateQuestionDimensionWatcher
              }
              getDimensionWatcher={props.getDimensionWatcher}
              updateDimensionWatcher={props.updateDimensionWatcher}
              updateQuestionWatcher={props.updateQuestionWatcher}
              getQuestionWatcher={props.getQuestionWatcher}
              getQuestionTypesWatcher={props.getQuestionTypesWatcher}
              isSurveyMandu={get(props, "surveyName.template_based", false)}
            />
          )
        })}

        {!!get(props.surveyEnps, "data", []).length && (
          <DimensionBoxEnps
            measures={get(props.surveyName, "measures", [])}
            updateQuestionWatcher={props.updateQuestionWatcher}
            toggleDrawer={props.setStateFrom}
            item={props.surveyEnps}
            getQuestionWatcher={props.getQuestionWatcher}
            getQuestionTypesWatcher={props.getQuestionTypesWatcher}
            hideThreePoints
            enps
            updateQuestionDimensionWatcher={
              props.updateQuestionDimensionWatcher
            }
            isSurveyMandu={get(props, "surveyName.template_based", false)}
          />
        )}

        {!!get(props.surveyQualitative, "data", []).length && (
          <DimensionBoxEnps
            // measures={get(props.surveyName, 'measures', [])}
            measures={
              get(props.surveyName, "measures[0].id_measure_status", 3) != 4
                ? []
                : ["no-disable"]
            }
            idSurvey={props.match.params.id}
            item={props.surveyQualitative}
            toggleDrawer={props.setStateFrom}
            updateQualitativeWatcher={props.updateQualitativeWatcher}
            getQuestionWatcher={props.getQuestionWatcher}
            updateQuestionDimensionWatcher={
              props.updateQuestionDimensionWatcher
            }
            getQuestionTypesWatcher={props.getQuestionTypesWatcher}
            isSurveyMandu={get(props, "surveyName.template_based", false)}
            showOptionsChildren
          />
        )}
        {!!get(props.listQuestionMultipleChoice, "data", []).length && (
          <DimensionBoxMultipleChoice
            idSurvey={props.match.params.id}
            measures={get(props.surveyName, "measures", [])}
            listQuestionMultipleChoice={props.listQuestionMultipleChoice}
            hideThreePoints
            toggleDrawer={props.setStateFrom}
            updateQuestionWatcher={props.updateQuestionWatcher}
            getQuestionWatcher={props.getQuestionWatcher}
            getQuestionTypesWatcher={props.getQuestionTypesWatcher}
            openModalDeleteQuestion={props.openModalDeleteQuestion}
            updateQuestionDimensionWatcher={
              props.updateQuestionDimensionWatcher
            }
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default SurveyQuestions
